const Papa = require("papaparse");

module.exports = function (
  JSONData,
  graphicTitle,
  response_type,
  time_periods,
  tObj,
  type
) {
  let T1, T2, T3;
  if (tObj) {
    T1 = tObj.T1;
    T2 = tObj.T2;
    T3 = tObj.T3;
  }

  // Format the response_type
  if (response_type) {
    response_type = response_type
      .toLowerCase()
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
      .join(" ");
    
    response_type = response_type === "Vegetation Mmi" ? "Vegetation MMI" : response_type;
  }

  // Set column sort order
  let fields;
  if (type === "condition") {
    fields = [
      "Condition",
      `Estimate`,
      `Lower Confidence Bound`,
      `Upper Confidence Bound`,
    ];
  } else if (type === "change") {
    const two_periods = [
      "Condition",
      `Statistically Significant Change from ${T1} to ${T2} (95% Confidence Level)`,
      `${T1} Estimate`,
      `${T1} Lower Confidence Bound`,
      `${T1} Upper Confidence Bound`,
      `${T2} Estimate`,
      `${T2} Lower Confidence Bound`,
      `${T2} Upper Confidence Bound`,
    ];

    const three_periods = [
      "Condition",
      `Statistically Significant Change from ${T2} to ${T3} (95% Confidence Level)`,
      `${T1} Estimate`,
      `${T1} Lower Confidence Bound`,
      `${T1} Upper Confidence Bound`,
      `${T2} Estimate`,
      `${T2} Lower Confidence Bound`,
      `${T2} Upper Confidence Bound`,
      `${T3} Estimate`,
      `${T3} Lower Confidence Bound`,
      `${T3} Upper Confidence Bound`,
    ];

    fields = time_periods.length === 2 ? two_periods : three_periods;
  } else if (type === "risk") {
    fields = [
      // There is a space after "Stressor " so that it matches clean_data_export.js
      "Stressor ",
      `Estimated Attributable Risk to ${response_type}`,
      `Lower Confidence Bound`,
      `Upper Confidence Bound`,
    ];
  }

  let d = Papa.unparse({ fields, data: JSONData });

  // Add title and annotations
  if (type !== "risk") {
    d = graphicTitle + "\r\n" + "\r\n" + d;
    d += "\r\n";
    d += "\r\n" + "Estimate values are rounded and may not add to 100%.";
    d += "\r\n" + "Document Generated: " + new Date();
  } else {
    d =
      graphicTitle +
      "\r\n" +
      `Response: ${response_type}` +
      "\r\n" +
      "\r\n" +
      d;
    d += "\r\n";
    d += "\r\n" + "Estimate values are rounded and may not add to 100%.";
    d += "\r\n" + "Document Generated: " + new Date();
  }

  return new Blob([d], { type: "text/csv" });
};
